import styled from 'styled-components';
import { FlexContainer } from 'Components/TabLinks/styles';
import { flexCenter, pxToRem } from 'Styles/utils/utils';
import { DESKTOP_WIDTH, HEADER_HEIGHT } from 'Styles/variables/sizes';

export const StyledHeader = styled.header`
  padding: ${({ theme }) => `${theme.spacing.spacing_16} ${theme.spacing.spacing_24}`};
  background: rgba(255, 255, 255, 0.6);
  height: ${HEADER_HEIGHT};
  ${flexCenter}
  >div:first-child {
    width: 100%;
  }
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    &.is-menu-desplayed {
      background: ${({ theme: { colors } }) => colors.green_200};
      border-bottom: none;
    }
    min-height: auto;
    padding: ${({ theme }) => theme.spacing.spacing_16};
  }
`;

export const StyledFlexContainer = styled(FlexContainer)`
  svg {
    margin-right: ${pxToRem(10)};
  }
`;

export const LogoContainer = styled.div`
  > div:first-child {
    display: none;
  }
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    > div:first-child {
      display: flex;
    }
    > img {
      display: none;
      width: auto;
    }
  }
`;

export const BackButtonContainer = styled.div`
  @media screen and (min-width: ${DESKTOP_WIDTH}) {
    display: none;
  }
`;
